import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistAnswerEditModel } from 'shared/domain/checklistAnswer/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistAnswerHttpEditRequestModel } from '../httpQueue/checklistAnswer/types';

export class ChecklistAnswerEditor {
  constructor(
    private addRequest: (
      request: ChecklistAnswerHttpEditRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    editModel: ChecklistAnswerEditModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('EditChecklistAnswerUseCase', editModel);

    const url = `/project/${editModel.projectId}/inspectionTemplate/${editModel.inspectionTemplateId}/checklistItem/${editModel.checklistItemId}/checklistAnswer/${editModel._id}`;

    const request: ChecklistAnswerHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        checklistAnswerOutDto: editModel.answer,
        answerId: editModel._id,
        projectId: editModel.projectId,
        inspectionTemplateId: editModel.inspectionTemplateId,
        checklistItemId: editModel.checklistItemId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistAnswer,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistAnswerEditor = new ChecklistAnswerEditor(addRequest);
